<template>
    <div  class="mpro wow">
        <div class="allItems">
           <div class="item1">
             <p>{{$t('home').mpro.text0[0]}}</p>
               <p>{{$t('home').mpro.text0[1]}}</p>
           </div>
            <div class="item" v-for="(item,index) in list" :key="index" @click="gotoInfo(item.id,item.parentid)">
              <div class="l">
                  <p>{{item.title}}</p>
              </div>
                <div class="r">
                    <img :src="`http://www.uni-sec.com/${item.picurl}`" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import  {getHomeInfo} from "../util/lang";
    export default {
        name: "mpro",
        data(){
          return{

          }
        },
        props:[
            'list'
        ],
        methods:{
            gotoInfo(id,tid){
                const  link=`/proInfo.html?id=${id}?tid=${tid}`
                window.open(link,'_blank')
            }
        }
    }
</script>

<style lang="scss" scoped>
.mpro{
    width:80%;
    margin: 60px auto;
    animation-duration: 2s;
    .allItems{
        width:100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .item1{
            width:33%;
            p:nth-child(1){
                color:#4A4A4A;
                font-size: 35px;
                font-family: "DINEngschriftStd";
                text-transform: uppercase;
                margin: 40px 0;
                position: relative;
                padding: 40px 0;
                &::after{
                    content:'';
                    display: inline-block;
                    width:122px;
                    height:1px;
                    background:rgba(28,139,72,1);
                    position: absolute;
                    bottom:0;
                    left:0;
                }
            }
            p:nth-child(2){
                color:#4A4A4A;
                font-family: "itbook";
            }
        }
        .item{
            width:33%;
            background-color: #F7F7F7;
            display: flex;
            flex-direction: column-reverse;
            justify-content: space-between;
            padding: 20px 0;
            height:255px;
           margin: 1px;
            cursor: pointer;
            .l{
                width:100%;
                margin-left: 5%;
                position: relative;
                p{
                    position: absolute;
                    bottom:0;
                    font-size: 20px;
                    font-family: "itbook";
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                    height:30px;
                    width:100%;
                    text-align: center;
                    transition: all 600ms;
                }
            }
            .r{
                margin-right: 5%;
                display: flex;
                width:100%;
                flex-direction: column;
                align-items: center;
                overflow: hidden;
                justify-content: center;
                img{
                    max-width: 55%;
                    object-fit: cover;
                    transition: all 600ms;
                    margin: 0 auto;
                }
            }
            &:hover{
                .l{
                    p{
                        color:#1C8B48;
                    }
                }
                .r{
                    img{
                        transform: scale(1.05);
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1000px){
     width:90%;
        margin: 15px auto;
        .allItems{
            flex-direction: column;
            .item1{
                p:nth-child(1){
                    padding: 10px 0;
                    margin: 15px 0;
                }
            }
            .item{
                margin-top: 30px;
                flex-direction: column;
                .l{
                    margin-left: 0;
                    p{
                        position: static;
                    }
                }
                .l,.r{
                    width:100%;
                }
            }
            .item1,.item{
                width:100%;
            }
        }
    }
}
</style>
